// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import axios from "axios";

// const AdminWorkerDetails = () => {
//   const { id, name } = useParams();
//   const [bills, setBills] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const fetchBills = async () => {
//     try {
//       const res = await axios.get(
//         `http://localhost/murugan/bills/get_by_worker.php?worker_id=${id}`
//       );

//       console.log(res.data);

//       // Filter usage bills (exclude deductions)
//       const usageBills = res.data.filter(
//         (bill) =>
//           bill.type !== "deduction" &&
//           String(bill.worker_id) === String(id) &&
//           bill.worker_name === name
//       );

//       setBills(usageBills);
//     } catch (err) {
//       console.error("Failed to fetch bills", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchBills();
//   }, [id, name]);

//   return (
//     <div className="p-4">
//       <h2 className="text-xl font-semibold mb-4">
//         Bills for {name} (ID: {id})
//       </h2>

//       {loading ? (
//         <p>Loading bills...</p>
//       ) : bills.length > 0 ? (
//         <div className="overflow-x-auto" style={{ maxHeight: "75vh" }}>
//           <table className="min-w-full border border-gray-300 text-sm md:text-base">
//             <thead className="bg-blue-600 text-white sticky top-0">
//               <tr>
//                 <th className="py-2 px-4 border">S.No</th>
//                 <th className="py-2 px-4 border">Bill Date</th>
//                 <th className="py-2 px-4 border">Product</th>
//                 <th className="py-2 px-4 border">Quantity</th>
//                 <th className="py-2 px-4 border">Price (₹)</th>
//                 <th className="py-2 px-4 border">Total (₹)</th>
//                 <th className="py-2 px-4 border">Grand Total (₹)</th>
//               </tr>
//             </thead>
//             <tbody>
//               {bills.map((bill, billIndex) =>
//                 bill.items.map((item, itemIndex) => (
//                   <tr
//                     key={`${billIndex}-${itemIndex}`}
//                     className="hover:bg-blue-50"
//                   >
//                     {itemIndex === 0 && (
//                       <>
//                         <td
//                           className="py-2 px-4 border text-center"
//                           rowSpan={bill.items.length}
//                         >
//                           {billIndex + 1}
//                         </td>
//                         <td
//                           className="py-2 px-4 border"
//                           rowSpan={bill.items.length}
//                         >
//                           {new Date(bill.date).toLocaleDateString()}
//                         </td>
//                       </>
//                     )}
//                     <td className="py-2 px-4 border">{item.product}</td>
//                     <td className="py-2 px-4 border">{item.quantity}</td>
//                     <td className="py-2 px-4 border">₹{item.price}</td>
//                     <td className="py-2 px-4 border">
//                       ₹{item.price * item.quantity}
//                     </td>
//                     {itemIndex === 0 && (
//                       <td
//                         className="py-2 px-4 border font-bold text-blue-700"
//                         rowSpan={bill.items.length}
//                       >
//                         ₹{bill.total}
//                       </td>
//                     )}
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>
//       ) : (
//         <p>No usage bills found.</p>
//       )}
//     </div>
//   );
// };

// export default AdminWorkerDetails;

// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import axios from "axios";

// // const AdminWorkerDetails = () => {
// //   const { id, name } = useParams();
// //   const [bills, setBills] = useState([]);
// //   const [loading, setLoading] = useState(true);

// //   const fetchBills = async () => {
// //     try {
// //       const res = await axios.get(
// //         `http://localhost/murugan/bills/get_by_worker.php?worker_id=${id}`
// //       );

// //       console.log(res.data);

// //       // Filter usage bills (exclude deductions)
// //       const usageBills = res.data.filter(
// //         (bill) =>
// //           bill.type !== "deduction" &&
// //           String(bill.worker_id) === String(id) &&
// //           bill.worker_name === name
// //       );

// //       setBills(usageBills);
// //     } catch (err) {
// //       console.error("Failed to fetch bills", err);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     fetchBills();
// //   }, [id, name]);

// //   return (
// //     <div className="p-4">
// //       <h2 className="text-xl font-semibold mb-4">
// //         Bills for {name} (ID: {id})
// //       </h2>

// //       {loading ? (
// //         <p>Loading bills...</p>
// //       ) : bills.length > 0 ? (
// //         <div className="overflow-x-auto" style={{ maxHeight: "75vh" }}>
// //           <table className="min-w-full border border-gray-300 text-sm md:text-base">
// //             <thead className="bg-blue-600 text-white sticky top-0">
// //               <tr>
// //                 <th className="py-2 px-4 border">S.No</th>
// //                 <th className="py-2 px-4 border">Bill Date</th>
// //                 <th className="py-2 px-4 border">Product</th>
// //                 <th className="py-2 px-4 border">Quantity</th>
// //                 <th className="py-2 px-4 border">Price (₹)</th>
// //                 <th className="py-2 px-4 border">Item Total (₹)</th>
// //                 <th className="py-2 px-4 border">Subtotal (₹)</th>
// //                 <th className="py-2 px-4 border">CGST (%)</th>
// //                 <th className="py-2 px-4 border">CGST Amt (₹)</th>
// //                 <th className="py-2 px-4 border">SGST (%)</th>
// //                 <th className="py-2 px-4 border">SGST Amt (₹)</th>
// //                 <th className="py-2 px-4 border">Grand Total (₹)</th>
// //               </tr>
// //             </thead>
// //             <tbody>
// //               {bills.map((bill, billIndex) =>
// //                 bill.items.map((item, itemIndex) => (
// //                   <tr
// //                     key={`${billIndex}-${itemIndex}`}
// //                     className="hover:bg-blue-50"
// //                   >
// //                     {itemIndex === 0 && (
// //                       <>
// //                         {/* Serial Number */}
// //                         <td
// //                           className="py-2 px-4 border text-center"
// //                           rowSpan={bill.items.length}
// //                         >
// //                           {billIndex + 1}
// //                         </td>
// //                         {/* Bill Date */}
// //                         <td
// //                           className="py-2 px-4 border"
// //                           rowSpan={bill.items.length}
// //                         >
// //                           {new Date(bill.date).toLocaleDateString()}
// //                         </td>
// //                       </>
// //                     )}

// //                     {/* Product details */}
// //                     <td className="py-2 px-4 border">{item.product}</td>
// //                     <td className="py-2 px-4 border">{item.quantity}</td>
// //                     <td className="py-2 px-4 border">₹{item.price}</td>
// //                     <td className="py-2 px-4 border">
// //                       ₹{(parseFloat(item.price) * item.quantity).toFixed(2)}
// //                     </td>

// //                     {/* Subtotal, CGST, SGST, Total only once per bill */}
// //                     {itemIndex === 0 && (
// //                       <>
// //                         <td
// //                           className="py-2 px-4 border font-semibold"
// //                           rowSpan={bill.items.length}
// //                         >
// //                           ₹{bill.subtotal}
// //                         </td>
// //                         <td
// //                           className="py-2 px-4 border"
// //                           rowSpan={bill.items.length}
// //                         >
// //                           {bill.cgst}%
// //                         </td>
// //                         <td
// //                           className="py-2 px-4 border"
// //                           rowSpan={bill.items.length}
// //                         >
// //                           ₹{bill.cgst_amount}
// //                         </td>
// //                         <td
// //                           className="py-2 px-4 border"
// //                           rowSpan={bill.items.length}
// //                         >
// //                           {bill.sgst}%
// //                         </td>
// //                         <td
// //                           className="py-2 px-4 border"
// //                           rowSpan={bill.items.length}
// //                         >
// //                           ₹{bill.sgst_amount}
// //                         </td>
// //                         <td
// //                           className="py-2 px-4 border font-bold text-blue-700"
// //                           rowSpan={bill.items.length}
// //                         >
// //                           ₹{bill.total}
// //                         </td>
// //                       </>
// //                     )}
// //                   </tr>
// //                 ))
// //               )}
// //             </tbody>
// //           </table>
// //         </div>
// //       ) : (
// //         <p>No usage bills found.</p>
// //       )}
// //     </div>
// //   );
// // };
// const AdminWorkerDetails = () => {
//   const { id, name } = useParams();
//   const [bills, setBills] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const fetchBills = async () => {
//     try {
//       const res = await axios.get(
//         `http://localhost/murugan/bills/get_by_worker.php?worker_id=${id}`
//       );

//       // Filter usage bills (exclude deductions)
//       const usageBills = res.data.filter(
//         (bill) =>
//           bill.type !== "deduction" &&
//           String(bill.worker_id) === String(id) &&
//           bill.worker_name === name
//       );

//       setBills(usageBills);
//     } catch (err) {
//       console.error("Failed to fetch bills", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchBills();
//   }, [id, name]);

//   return (
//     <div className="billing-container">
//       <h2 className="text-xl font-semibold mb-4">
//         Bills for {name} (ID: {id})
//       </h2>

//       {loading ? (
//         <p>Loading bills...</p>
//       ) : bills.length > 0 ? (
//         <div className="billing-table-wrap">
//           <table className="billing-table">
//             <thead>
//               <tr>
//                 <th>S.No</th>
//                 <th>Bill Date</th>
//                 <th>Product</th>
//                 <th>Quantity</th>
//                 <th>Price (₹)</th>
//                 <th>Item Total (₹)</th>
//                 <th>Subtotal (₹)</th>
//                 <th>CGST (%)</th>
//                 <th>CGST Amt (₹)</th>
//                 <th>SGST (%)</th>
//                 <th>SGST Amt (₹)</th>
//                 <th>Grand Total (₹)</th>
//               </tr>
//             </thead>
//             <tbody>
//               {bills.map((bill, billIndex) =>
//                 bill.items.map((item, itemIndex) => (
//                   <tr key={`${billIndex}-${itemIndex}`}>
//                     {itemIndex === 0 && (
//                       <>
//                         {/* Serial Number */}
//                         <td rowSpan={bill.items.length} className="center">
//                           {billIndex + 1}
//                         </td>
//                         {/* Bill Date */}
//                         <td rowSpan={bill.items.length}>
//                           {new Date(bill.date).toLocaleDateString()}
//                         </td>
//                       </>
//                     )}

//                     {/* Product details */}
//                     <td>{item.product}</td>
//                     <td className="center">{item.quantity}</td>
//                     <td className="right">₹{item.price}</td>
//                     <td className="right">
//                       ₹{(parseFloat(item.price) * item.quantity).toFixed(2)}
//                     </td>

//                     {/* Subtotal, CGST, SGST, Total only once per bill */}
//                     {itemIndex === 0 && (
//                       <>
//                         <td rowSpan={bill.items.length} className="right">
//                           ₹{bill.subtotal}
//                         </td>
//                         <td rowSpan={bill.items.length} className="center">
//                           {bill.cgst}%
//                         </td>
//                         <td rowSpan={bill.items.length} className="right">
//                           ₹{bill.cgst_amount}
//                         </td>
//                         <td rowSpan={bill.items.length} className="center">
//                           {bill.sgst}%
//                         </td>
//                         <td rowSpan={bill.items.length} className="right">
//                           ₹{bill.sgst_amount}
//                         </td>
//                         <td
//                           rowSpan={bill.items.length}
//                           className="right font-bold text-blue-700"
//                         >
//                           ₹{bill.total}
//                         </td>
//                       </>
//                     )}
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>
//       ) : (
//         <p>No usage bills found.</p>
//       )}
//     </div>
//   );
// };

// export default AdminWorkerDetails;

// // export default AdminWorkerDetails;

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Api } from "../Api/Api";

const StaffWorkerDetails = () => {
  const { id, name } = useParams();
  const [bills, setBills] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchBills = async () => {
    try {
      const res = await axios.get(
        `${Api}bills/get_by_worker.php?worker_id=${id}`
      );

      // Filter usage bills (exclude deductions)
      const usageBills = res.data.filter(
        (bill) =>
          bill.type !== "deduction" &&
          String(bill.worker_id) === String(id) &&
          bill.worker_name === name
      );

      setBills(usageBills);
    } catch (err) {
      console.error("Failed to fetch bills", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBills();
  }, [id, name]);

  return (
    // <div className="max-w-6xl mx-auto p-4 sm:p-6 bg-white shadow rounded mt-10">
    <div className="max-w-5xl mx-auto p-4 sm:p-6 bg-white shadow rounded mt-10">
      <h2 className="text-2xl font-semibold mb-6 text-center">
        Bills for {name} (ID: {id})
      </h2>

      {loading ? (
        <div className="text-center text-gray-600">Loading bills...</div>
      ) : bills.length > 0 ? (
        <div className="w-full overflow-x-auto">
          <table className="min-w-[700px]  border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-2 text-left whitespace-nowrap">
                  S.No
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left whitespace-nowrap">
                  Bill Date
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left whitespace-nowrap">
                  Invoice no
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left whitespace-nowrap">
                  Product
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left whitespace-nowrap">
                  Quantity
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left whitespace-nowrap">
                  Price (₹)
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left whitespace-nowrap">
                  Item Total (₹)
                </th>
                <th className="border border-gray-300 px-4 py-2 text-left whitespace-nowrap">
                  Subtotal (₹)
                </th>

                <th className="border border-gray-300 px-4 py-2 text-left whitespace-nowrap">
                  Grand Total (₹)
                </th>
              </tr>
            </thead>
            <tbody>
              {bills.map((bill, billIndex) =>
                bill.items.map((item, itemIndex) => (
                  <tr
                    key={`${billIndex}-${itemIndex}`}
                    className="hover:bg-gray-50"
                  >
                    {itemIndex === 0 && (
                      <>
                        <td
                          className="border border-gray-300 px-4 py-2 text-center"
                          rowSpan={bill.items.length}
                        >
                          {billIndex + 1}
                        </td>
                        {/* <td
                          className="border border-gray-300 px-4 py-2"
                          rowSpan={bill.items.length}
                        >
                          {new Date(bill.date).toLocaleDateString()}
                        </td> */}
                        <td
                          className="border border-gray-300 px-4 py-2"
                          rowSpan={bill.items.length}
                        >
                          {bill.bill_date
                            ? new Date(bill.bill_date).toLocaleDateString(
                                "en-GB"
                              ) // DD/MM/YYYY
                            : "N/A"}
                        </td>

                        <td
                          className="border border-gray-300 px-4 py-2"
                          rowSpan={bill.items.length}
                        >
                          {bill.invoice_no}
                        </td>
                      </>
                    )}

                    <td className="border border-gray-300 px-4 py-2">
                      {item.product}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      {item.quantity}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      ₹{item.price}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      ₹{(parseFloat(item.price) * item.quantity).toFixed(2)}
                    </td>

                    {itemIndex === 0 && (
                      <>
                        <td
                          className="border border-gray-300 px-4 py-2 font-semibold"
                          rowSpan={bill.items.length}
                        >
                          ₹{bill.subtotal}
                        </td>

                        <td
                          className="border border-gray-300 px-4 py-2 font-bold text-blue-700"
                          rowSpan={bill.items.length}
                        >
                          ₹{bill.total}
                        </td>
                      </>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center text-gray-500 py-6">
          No usage bills found.
        </div>
      )}
    </div>
  );
};

export default StaffWorkerDetails;
